<template>
	<wt-selector ref="select" :options="options" v-model="Value" :clearable="true" :allow-create="true" :filterable="true"></wt-selector>
</template>
<script>
export default {
  name: 'order-sampleType-selector',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getOptions () {
      let params = { page: 0, size: 99999999 }
      let options = []
      this.$store.dispatch('geConfigSuiteNames', params).then(data => {
        data.forEach(ele => {
          let obj = {
            label: ele,
            value: ele
          }
          options.push(obj)
        })
        this.options = options
      })
    }
  },
  created () {
    this.getOptions()
  },
  mounted () {
    // 获得 input 的 DOM
    let input = this.$refs.select.$el.querySelector('input')
    // 获得下拉菜单的 vm
    let dropdown = this.$refs.select.$children[0].$children.find(child => child.$options._componentTag === 'el-select-menu')
    input.addEventListener('blur', () => {
      let valDiy = dropdown.$children[0].$children.filter(child => child.visible)[0].value
      if (!this.options.map(e => e.value).includes(valDiy)) {
        // 将 value8 赋值为下拉菜单里第一个可见（即通过了筛选）的选项的 value 属性
        this.Value = valDiy
      }
    })
  }
}
</script>
